/**
 * Sistema de Suma de Precios de Addons - Tema Shrine
 * Versión 9 - Soporte Completo de Variantes de Addon + JSON Parsing
 */

(function() {
  'use strict';

  // Configuración de selectores basada en tu HTML
  const CONFIG = {
    selectors: {
      mainPrice: '.price__sale .price-item--sale, .product__price .price-item--sale',
      stickyPrice: '.sticky-add-to-cart .price__sale .price-item--sale, .sticky-atc .price-item--sale',
      
      // Contenedor principal del addon
      upsellItem: 'product-info-upsell', 
      
      // Selectores internos del addon (basados en tu código)
      toggleButton: '.upsell__toggle-switch',
      variantDropdown: '.variant-dropdown', // El select que cambia el tamaño
      jsonScript: 'script[type="application/json"]', // Donde están los datos de variantes
      
      // Contenedor general
      upsellContainer: '.product-info-upsells-container'
    }
  };

  let state = {
    basePrice: 0,
    activeAddonsTotal: 0,
    currencySymbol: '$',
    currencySuffix: '',
    observer: null,
    isProcessing: false
  };

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startSystem);
    } else {
      startSystem();
    }
  }

  function startSystem() {
    console.log('🚀 V9 Upsell System (Variantes + JSON)');
    
    detectCurrency();
    
    // Capturar precio base inicial
    const priceEl = document.querySelector(CONFIG.selectors.mainPrice);
    if (priceEl) {
      state.basePrice = parsePrice(priceEl.textContent);
      markPriceElement(priceEl, 0); 
    }

    recalculateAddonsTotal();
    updateVisualPrices();
    
    setupListeners();
  }

  // ==========================================
  // LÓGICA CORE
  // ==========================================

  function updateVisualPrices() {
    state.isProcessing = true; 

    // Calcular precio final
    const finalPrice = state.basePrice + state.activeAddonsTotal;
    const formattedPrice = formatMoney(finalPrice);

    // Actualizar Precio Principal
    const mainPrices = document.querySelectorAll(CONFIG.selectors.mainPrice);
    mainPrices.forEach(el => {
      if (el.textContent !== formattedPrice) {
        el.textContent = formattedPrice;
      }
      el.setAttribute('data-added-amount', state.activeAddonsTotal);
    });

    // Actualizar Sticky Bar
    const stickyPrices = document.querySelectorAll(CONFIG.selectors.stickyPrice);
    stickyPrices.forEach(el => {
      el.textContent = formattedPrice;
    });

    setTimeout(() => { state.isProcessing = false; }, 50);
  }

  function handlePriceMutation() {
    if (state.isProcessing) return;

    const priceEl = document.querySelector(CONFIG.selectors.mainPrice);
    if (!priceEl) return;

    const addedAmountAttr = priceEl.getAttribute('data-added-amount');
    const currentTextPrice = parsePrice(priceEl.textContent);

    if (addedAmountAttr === null) {
      // Cambio de variante del producto principal
      console.log('🔄 Variante Principal cambiada. Nuevo Base:', currentTextPrice);
      state.basePrice = currentTextPrice;
      updateVisualPrices();
    } else {
      const previousAdded = parseFloat(addedAmountAttr);
      const calculatedBase = currentTextPrice - previousAdded;
      if (Math.abs(calculatedBase - state.basePrice) > 0.1) {
        state.basePrice = currentTextPrice - previousAdded;
      }
    }
  }

  // ==========================================
  // MANEJO DE ADDONS Y VARIANTES
  // ==========================================

  /**
   * Esta función se activa cuando cambias el tamaño del addon
   */
  function handleAddonVariantChange(selectElement) {
    const container = selectElement.closest(CONFIG.selectors.upsellItem);
    if (!container) return;

    const selectedValue = selectElement.value; // Ej: "18x24\""
    const script = container.querySelector(CONFIG.selectors.jsonScript);

    if (script) {
      try {
        const variants = JSON.parse(script.textContent);
        
        // Buscar la variante que coincida con el valor seleccionado
        // Comparamos option1, title, o id
        const matchedVariant = variants.find(v => 
          v.title === selectedValue || 
          v.option1 === selectedValue || 
          v.id == selectedValue
        );

        if (matchedVariant) {
          // ACTUALIZAMOS EL ATRIBUTO DATA-PRICE DEL PADRE
          // El JSON suele traer el precio en centavos (Ej: 9000), así que lo guardamos tal cual
          // Nuestra función recalculate se encargará de dividirlo si es necesario
          container.setAttribute('data-price', matchedVariant.price);
          
          // Opcional: Actualizar también el input hidden ID para que el carrito funcione bien
          const hiddenInput = container.querySelector('input[name="id"]');
          if (hiddenInput) hiddenInput.value = matchedVariant.id;

          console.log(`🎛️ Variante Addon cambiada: ${matchedVariant.title} -> Precio: ${matchedVariant.price}`);
        }
      } catch (e) {
        console.error('Error leyendo JSON del addon:', e);
      }
    }

    // Recalcular todo inmediatamente
    recalculateAddonsTotal();
    updateVisualPrices();
  }

  function recalculateAddonsTotal() {
    let total = 0;
    // Buscamos tanto por clase upsell como por tag product-info-upsell
    const upsells = document.querySelectorAll(CONFIG.selectors.upsellItem);
    
    upsells.forEach(upsell => {
      // Verificamos si está activo (toggle on)
      const isSelected = upsell.getAttribute('data-selected') === 'true' || 
                         (upsell.querySelector('input[type="checkbox"]') && upsell.querySelector('input[type="checkbox"]').checked);

      if (isSelected) {
        const priceAttr = upsell.getAttribute('data-price');
        
        if (priceAttr) {
          let rawPrice = parseFloat(priceAttr);
          let finalItemPrice = rawPrice;

          // Detección Inteligente de Unidades (Centavos vs Dolares)
          // Si es > 500, asumimos centavos (Ej: 6000 -> 60.00)
          if (rawPrice > 500) {
             finalItemPrice = rawPrice / 100;
          }
          
          total += finalItemPrice;
        }
      }
    });

    state.activeAddonsTotal = total;
  }

  // ==========================================
  // LISTENERS
  // ==========================================

  function setupListeners() {
    // 1. Click en Toggles (Activar/Desactivar Addon)
    document.addEventListener('click', (e) => {
      if (e.target.closest(CONFIG.selectors.toggleButton)) {
        setTimeout(() => {
          recalculateAddonsTotal();
          updateVisualPrices();
        }, 50);
      }
    });

    // 2. Cambio en Dropdown de Variantes (NUEVO)
    // Usamos 'change' event delegado
    document.addEventListener('change', (e) => {
      if (e.target.matches(CONFIG.selectors.variantDropdown)) {
        handleAddonVariantChange(e.target);
      }
    });

    // 3. Observer para el precio base del producto principal
    const targetNode = document.querySelector('.product-section') || document.body;
    
    state.observer = new MutationObserver((mutations) => {
      const priceEl = document.querySelector(CONFIG.selectors.mainPrice);
      if (priceEl && !state.isProcessing) {
        handlePriceMutation();
      }
    });

    state.observer.observe(targetNode, { 
      childList: true, 
      subtree: true,
      characterData: true 
    });
  }

  function parsePrice(text) {
    if (!text) return 0;
    const match = text.match(/[\d,.]+/);
    if (!match) return 0;
    let clean = match[0].replace(/,/g, ''); 
    return parseFloat(clean);
  }

  function markPriceElement(el, addedAmount) {
    el.setAttribute('data-added-amount', addedAmount);
  }

  function formatMoney(amount) {
    return state.currencySymbol + 
           amount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + 
           state.currencySuffix;
  }

  function detectCurrency() {
    const el = document.querySelector(CONFIG.selectors.mainPrice);
    if (el) {
      const txt = el.textContent;
      if (txt.includes('USD')) state.currencySuffix = ' USD';
      if (txt.includes('$')) state.currencySymbol = '$';
      else if (txt.includes('€')) state.currencySymbol = '€';
    }
  }

  init();
})();